export const IMAGES = {
  ANNUAL_DAY:
    "https://soomuch.blob.core.windows.net/data-soomuch/DemoContent/DemoEvents/AnnualDay.jpg",
  SCIENCE_FAIR:
    "https://soomuch.blob.core.windows.net/data-soomuch/DemoContent/DemoEvents/ScienceFair.jpg",
  SPORTS_DAY:
    "https://soomuch.blob.core.windows.net/data-soomuch/DemoContent/DemoEvents/SportsDay.jpg",
};

export const VIDEOS = {
  SOCIAL_HUB_INTRO:
    "https://soomuch.blob.core.windows.net/data-soomuch/DemoContent/DemoEvents/intro.mp4",
  ANNUAL_DAY:
    "https://soomuch.blob.core.windows.net/data-soomuch/DemoContent/DemoEvents/AnnualDay.mp4",
  SCIENCE_FAIR:
    "https://soomuch.blob.core.windows.net/data-soomuch/DemoContent/DemoEvents/ScienceFair.mp4",
  SPORTS_DAY:
    "https://soomuch.blob.core.windows.net/data-soomuch/DemoContent/DemoEvents/SportsDay.mp4",
};

export const getImageURLBasedOnEvent = (event) => {
  switch (event) {
    case "Annual Day":
      return IMAGES.ANNUAL_DAY;
    case "Science Fair":
      return IMAGES.SCIENCE_FAIR;
    case "Sports Day":
      return IMAGES.SPORTS_DAY;
    default:
      return "";
  }
};

export const getVideoURLBasedOnEvent = (event) => {
  switch (event) {
    case "Social Hub Intro":
      return VIDEOS.SOCIAL_HUB_INTRO;
    case "Annual Day":
      return VIDEOS.ANNUAL_DAY;
    case "Science Fair":
      return VIDEOS.SCIENCE_FAIR;
    case "Sports Day":
      return VIDEOS.SPORTS_DAY;
    default:
      return "";
  }
};
